import copyToClipboard from 'copy-to-clipboard'
import alertService from '../services/alert.service'

export default {
  copy (text: string) {
    copyToClipboard(text)
    alertService.success('Copied to clipboard')
  }
}
